<template>
  <b-table
    v-on="$listeners"
    v-bind.sync="$attrs"
    :bordered="false"
    :sticky-header="false"
    show-empty
    no-sort-reset
    responsive
  >
    <template #head()="{ label, field: { key, sortable }}">
      {{ label }}
      <template v-if="sortable">
        <template>
          <b-icon
            v-if="$attrs['sort-by'] !== key"
            icon="arrow-up-down"
          ></b-icon>

          <b-icon
            v-else-if="$attrs['sort-desc']"
            icon="arrow-down"
          ></b-icon>

          <b-icon
            v-else
            icon="arrow-up"
          ></b-icon>
        </template>
      </template>
    </template>

    <template
      v-for="(index, name) in $scopedSlots"
      v-slot:[name]="data">
        <slot
          v-bind="data"
          :name="name">
        </slot>
    </template>

    <template #table-busy>
      <div class="table-loading">
        <div class="text-center">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </div>
    </template>

    <template #empty>
      <div class="text-center text-nowrap my-2">
        {{ emptyText || getTrans('label.no_record_found') }}
      </div>
    </template>
  </b-table>
</template>

<script>
/**
 * This component is a b-table wrapper
 * to set a standard styling and usage for table
 */
export default {
  name: 'AppTable',
  props: {
    emptyText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wrapper-outer {
  position: relative;
}

/deep/ .b-table-sticky-header,
.table-responsive,
[class*="table-responsive-"] {
  margin-bottom: 0;
}

/deep/ .table {
  thead th,
  tbody td {
    padding: 20px;
    font-weight: normal;
  }

  th {
    word-break: keep-all;
    white-space: nowrap;
    background-image: none !important;

    .b-icon.bi {
      color: $gray-primary;
    }
  }

  .table-loading {
    color: $light-gray-text;
    display: inline-block;
    position: sticky;
    left: 50%;
    padding: 1.5rem .5rem;
    > * {
      transform: translateX(-50%);
    }
    > td { border: 0; }
  }

  .b-table-empty-row {
    color: $light-gray-text;
  }
}
</style>